import { Injectable, inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { CharPadderPipe } from '@aston/foundation';

import { DunningActionsService } from '../../../dunnings-module/services';
import { DunningTimelineStore } from '../../../dunnings-module/stores';
import * as AppStoreActions from '../../app-store/actions';
import * as featureActions from '../actions';

@Injectable({
	providedIn: 'root'
})
export class DunningActionDetailStoreDeletionEffects {

	private dunningActionsService = inject(DunningActionsService);
	private tlStore = inject(DunningTimelineStore);
	private actions$ = inject(Actions);
	private store = inject(Store);

	deleteDunningActionConfirm$: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType(featureActions.DeleteDunningActionConfirm),
		map(action => {
			const dunningActionNumber = new CharPadderPipe().transform(action.entity.id, 8);
			return AppStoreActions.OpenConfirmationModal({
				textsKey: `Dunning.Confirmations.DeleteDunningAction.`,
				questionParams: {data: {number: dunningActionNumber}}
			}, featureActions.DeleteDunningActionRequest(action.entity.id));
		})
	));

	deleteDunningActionRequest$: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType(featureActions.DeleteDunningActionRequest),
		switchMap(action => this.dunningActionsService.deleteDunningAction(action.id).pipe(
			map(() => featureActions.DeleteDunningActionSuccess()),
			catchError(error => of(featureActions.DeleteDunningActionFailure({error})))
		))
	));

	deleteDunningActionSuccess$: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType(featureActions.DeleteDunningActionSuccess),
		withLatestFrom(this.store),
		map(([_]) => AppStoreActions.Execute(() => this.tlStore.loadTimeline()))
	));

	deleteDunningActionFailure$: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType(featureActions.DeleteDunningActionFailure),
		map(action => AppStoreActions.ToastError(action.error.message))
	), {dispatch: false});

}
